import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';
import { ProviderEnrollmentInsurancePlanViewModel } from '../models/provider-enrollment-insurance-plan/provider-enrollment-insurance-plan/provider-enrollment-insurance-plan-view-model';
import { ProviderListOptionRequest } from '../models/providers';
import { SalesOrderProviderListOption } from '../models/sales-orders';

@Injectable({
  providedIn: 'root'
})
export class ProviderDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getProviderOptionsAsync(query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('providers/options', request, cancellationToken);
  }

  public getClinicProviderOptionsAsync(query: string, clinicId: number = null, timeout: Promise<any>): Promise<ListOption<number>[]> {
    const request: ProviderListOptionRequest = { searchString: query, clinicId: clinicId };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('providers/ClinicProviders', request, timeout, false);
  }

  public getClinicProviderWithUserOptionsAsync(query: string, clinicId: number = null, timeout: Promise<any>): Promise<SalesOrderProviderListOption[]> {
    const request: ProviderListOptionRequest = { searchString: query, clinicId: clinicId };
    return this.httpClient.getJsonAsync<SalesOrderProviderListOption[]>('providers/ClinicProvidersWithUser', request, timeout, false);
  }

  public getActiveClinicProviderOptionsAsync(query: string, clinicId: number = null, timeout: Promise<any>): Promise<ListOption<number>[]> {
    const request: ProviderListOptionRequest = { searchString: query, clinicId: clinicId };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('providers/ActiveClinicProviders', request, timeout, false);
  }

  public checkIdentifierExists(identifier: string, providerId: number, timeout: Promise<any>): Promise<boolean> {
    const data = {identifier: identifier, providerId: providerId};

    return this.httpClient.getJsonAsync<boolean>('providers/checkIdentifierExists', data, timeout, false);
  }

  public checkActiveProvider(providerId: number, timeout: Promise<any>): Promise<boolean> {
    const data = { providerId: providerId };

    return this.httpClient.getJsonAsync<boolean>('providers/checkActiveProvider', data, timeout, false);
  }

  public checkProviderClinicExists(providerId: number, clinicId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = {clinicId: clinicId, providerId: providerId, id: id};

    return this.httpClient.getJsonAsync<boolean>('providerClinics/checkLinkExists', data, timeout, false);
  }

  public deleteProviderAcademicDegreeAsync(id: number | string, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ProviderAcademicDegrees/Delete', id, timeout);
  }

  public checkAcademicDegreeExists(academicDegreeId: number, providerId: number, timeout: Promise<any>): Promise<boolean> {
    const data = { academicDegreeId: academicDegreeId, providerId: providerId };

    return this.httpClient.getJsonAsync<boolean>('ProviderAcademicDegrees/CheckAcademicDegreeExists', data, timeout, false);
  }

  public checkClinicHasActiveProvider(clinicId: number, timeout: Promise<any>): Promise<boolean> {
    const data = {clinicId: clinicId};

    return this.httpClient.getJsonAsync<boolean>('providers/checkClinicHasActiveProvider', data, timeout);
  }
 
  onAddInsurancePlansAction(insurancePlanIds: number[], providerId: number, cancellation: Promise<any>): Promise<any> {
    const request: ProviderEnrollmentInsurancePlanViewModel = {
      providerIds: null,
      insurancePlanIds: insurancePlanIds,
      insurancePlanName: null,
      isActive: true,
      providerName: null,
      providerId: providerId,
      isNetworkProvider:false
    };
    return this.httpClient.postJsonAsync('ProviderInsurancePlans/AddInsurancePlans', request, cancellation);
  }
  deactivateInsurancePlansAsync(providerId: number, selectedIds: number[], cancellation: Promise<any>): Promise<number> {
    const request = {} as ProviderEnrollmentInsurancePlanViewModel;
    request.selectedIds = selectedIds;
    request.providerId = providerId;
    return this.httpClient.postJsonAsync('ProviderInsurancePlans/DeactivateInsurancePlan', request, cancellation);
  }
}
